<template>
  <BasePageTemplate
    :title="successTitleString"
    :description="successDescriptionString"
  >
    <div class="flex justify-content-center">
      <AnimatedIcon icon="success" size="7xl" />
    </div>

    <MainButton
      :label="backToLoginString"
      @click="onBackToLoginClickAsync" />
  </BasePageTemplate>
</template>

<script setup lang="ts">
import {useTranslation} from 'i18next-vue';
import {AnimatedIcon} from '@common/ui/atoms/Icons/AnimatedIcon';
import {BasePageTemplate} from '@authentication/ui';
import {MainButton} from '@common/ui';
import {Endpoints} from '@authentication/constants';
import {useRedirectionTools} from '@authentication/hooks';
import {nextTick, onMounted} from 'vue';

// Variables
const {t} = useTranslation();
const redirectionTools = useRedirectionTools();

// Strings
const backToLoginString = t('reset_credentials.back_to_login');
const successDescriptionString = t('reset_credentials.success_description');
const successTitleString = t('reset_credentials.success_title');

// Methods
const onBackToLoginClickAsync = async () => {
  await redirectionTools.redirectToAsync(Endpoints.pageSignInPath);
};

// Hooks
onMounted(async () => {
  await nextTick(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  });
});
</script>